import { useTranslation } from 'react-i18next';

import * as graphql from '@treams/treams-network';
import { Paragraph } from '@treams/treams-ui';

import BulkModal from './BulkModal';

export default function BulkObfuscateUserModal(props: {
	users: graphql.User[];
	onDismiss: () => void;
}) {
	const { t } = useTranslation();

	const [obfuscateUser] = graphql.useObfuscateUserMutation();

	return (
		<BulkModal
			name="bulkObfuscate"
			valid
			apply={async (user) => {
				await obfuscateUser({
					variables: {
						input: {
							id: user.id,
							username: user.username,
						},
					},
				});
			}}
			users={props.users}
			onDismiss={props.onDismiss}
		>
			<Paragraph mb={4} whiteSpace="pre-line">
				{t('employees.bulkObfuscate.instructions')}
			</Paragraph>
		</BulkModal>
	);
}
